export const indexReducedPattern = "index-reduced-royalty-calculation-*";
